import * as THREE from "three";
import { doorDestination, doorLanding, insideHouse } from "@catworld/shared";

export class DoorInteraction {
  /** @param {{ player: import('@catworld/engine').Player, scene: THREE.Scene,
   * getNet: () => import('./net/index.js').Net | null,
   * onTravel: (landing: import('@catworld/shared').DoorLanding) => void }} options */
  constructor({ player, scene, getNet, onTravel }) {
    this.player = player; this.getNet = getNet; this.onTravel = onTravel;
    this.lastRequest = -Infinity;
    this.hint = document.createElement("div");
    this.hint.id = "door-hint"; this.hint.className = "panel hidden";
    document.body.appendChild(this.hint);
    this.fade = document.createElement("div"); this.fade.id = "door-fade";
    document.body.appendChild(this.fade);
    this.lights = new THREE.Group(); this.lights.name = "Interior warm lighting";
    for (const [x,y,z] of [[0,2.9,-1.5],[-2.5,2.9,-6],[2.5,2.9,-10.6],[-3,2.9,-11],
      [-2,5.8,-4],[2,5.8,-10],[-2,.2,-4],[2,.2,-10]]) {
      const light = new THREE.PointLight(0xffe1b4, 10, 8, 2);
      light.position.set(x,y,z); this.lights.add(light);
    }
    scene.add(this.lights);
    this.update();
  }

  update() {
    const p = this.player.pos;
    const destination = this.player.grounded ? doorDestination(p.x,p.y,p.z) : null;
    this.hint.classList.toggle("hidden", !destination);
    if (destination) this.hint.textContent = destination.side === "inside"
      ? (destination.door === "rear" ? "Meow · V to enter the kitchen" : "Meow · V to come inside")
      : (destination.door === "rear" ? "Meow · V to go onto the deck" : "Meow · V to go outside");
    this.lights.visible = insideHouse(p.x,p.y,p.z);
  }

  meow() {
    const p = this.player.pos;
    const destination = doorDestination(p.x,p.y,p.z);
    if (!destination || !this.player.grounded || performance.now() - this.lastRequest < 1200) return;
    this.lastRequest = performance.now();
    const net = this.getNet();
    if (net && !net.offline) net.meow();
    else this.arrive(destination);
  }

  /** @param {{side: string, door?: string}} message */
  arrive(message) {
    const landing = doorLanding(message.side, message.door);
    if (!landing) return;
    this.onTravel(landing);
    this.fade.animate([{opacity: .9}, {opacity: 0}], {
      duration: matchMedia("(prefers-reduced-motion: reduce)").matches ? 100 : 380,
    });
    this.update();
  }
}
